import { render, staticRenderFns } from "./UndefinedIcon.vue?vue&type=template&id=6e15229c&functional=true&"
import script from "./UndefinedIcon.vue?vue&type=script&lang=js&"
export * from "./UndefinedIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports